<template>
    <div class="permission-container">
        <!-- 面包屑导航 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-view"></i> 权限设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <!-- 当前用户提示 - 放到顶部 -->
            <div class="user-info-banner">
                <i class="el-icon-user-solid"></i>
                <span>正在为用户 <strong>{{ user }}</strong> 配置权限</span>
            </div>

            <!-- 操作区域卡片 -->
            <el-card class="operation-card" shadow="hover">
                <div class="operation-wrapper">
                    <!-- 复制权限和权限配置左右布局 -->
                    <div class="operation-row">
                        <!-- 复制权限区域 - 占 1/3 -->
                        <div class="operation-section one-third">
                            <div class="section-title">
                                <i class="el-icon-document-copy"></i>
                                <span>复制权限</span>
                            </div>
                            <div class="section-content">
                                <el-select 
                                    v-model="bar" 
                                    filterable 
                                    placeholder="请选择用户" 
                                    class="user-select"
                                >
                                    <el-option 
                                        v-for="(item, index) in selectData" 
                                        :key="index" 
                                        :label="item.staffr_name" 
                                        :value="item.login_staff"
                                    >
                                        <span class="option-label">
                                            <span class="staff-code">{{ item.login_staff }}</span>
                                            <span class="staff-name">{{ item.staffr_name }}</span>
                                        </span>
                                    </el-option>
                                </el-select>
                                <el-button type="warning" icon="el-icon-document-copy" @click="handleCopy">复制</el-button>
                            </div>
                        </div>

                        <!-- 权限配置区域 - 占 2/3 -->
                        <div class="operation-section two-thirds">
                            <div class="section-title">
                                <i class="el-icon-s-custom"></i>
                                <span>权限配置</span>
                            </div>
                            <div class="section-content permission-config">
                                <div class="config-item">
                                    <span class="config-label">权限等级：</span>
                                    <el-select 
                                        v-model="level" 
                                        filterable 
                                        placeholder="请选择等级" 
                                        @change="selectLevel"
                                        class="level-select"
                                    >
                                        <el-option 
                                            v-for="(item, index) in levelData" 
                                            :key="index" 
                                            :label="'等级 ' + item" 
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                    <el-tooltip content="模块单据查阅权限 等级1:仅自己 | 等级2:同部门 | 等级3:跨部门 | 等级4:全部" placement="top">
                                        <i class="el-icon-question info-icon"></i>
                                    </el-tooltip>
                                </div>
                                <div class="config-item">
                                    <span class="config-label">查看成本：</span>
                                    <el-tag 
                                        :type="String(perData_cost.allow_cost) === '1' ? 'success' : 'danger'"
                                        size="small"
                                    >
                                        {{ String(perData_cost.allow_cost) === '1' ? '启用' : '停用' }}
                                    </el-tag>
                                    <el-switch
                                        v-model="perData_cost.allow_cost"
                                        :active-value="1"
                                        :inactive-value="0"
                                        @change="tableDatastates(perData_cost.allow_cost)"
                                        active-color="#0084ff"
                                    />
                                </div>
                                <div class="config-item">
                                    <span class="config-label">允许低价开单：</span>
                                    <el-tag 
                                        :type="String(perData_cost.allow_lowerprc) === '1' ? 'success' : 'danger'"
                                        size="small"
                                    >
                                        {{ String(perData_cost.allow_lowerprc) === '1' ? '启用' : '停用' }}
                                    </el-tag>
                                    <el-switch
                                        v-model="perData_cost.allow_lowerprc"
                                        :active-value="1"
                                        :inactive-value="0"
                                        @change="tableDatastatesLowerprc(perData_cost.allow_lowerprc)"
                                        active-color="#0084ff"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
            <!-- Tabs 标签页切换 -->
            <el-card class="table-card" shadow="hover">
                <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
                    <!-- 功能权限标签页 -->
                    <el-tab-pane name="function">
                        <span slot="label">
                            <i class="el-icon-menu"></i>
                            功能权限
                        </span>
                        <el-table
                            :data="permisson"
                            border
                            stripe
                            style="width: 100%"
                            :header-cell-style="{ background: '#ecf5ff', color: '#0084ff', fontWeight: 'bold' }"
                            :span-method="objectSpanMethod"
                            v-loading="dataLoading"
                            element-loading-text="加载中..."
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 255, 255, 0.8)"
                        >
                            <el-table-column label="系统" width="150" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.type_name_s" class="system-name">
                                        {{ scope.row.word.type_name }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="word.chinese" label="页面" min-width="120" align="center"></el-table-column>
                            <el-table-column v-for="(item, index) in tableData" :key="index" :label="item.chinese" width="100" align="center">
                                <template slot="header" slot-scope="scope">
                                    <div class="column-header">
                                        <span>{{ item.chinese }}</span>
                                        <div class="column-actions" v-if="perData && perData.allow_edit == 1">
                                            <el-tooltip content="全开" placement="top">
                                                <i class="el-icon-circle-check header-action-btn open-all" @click="handleColumnBatchToggle(item, 'open')"></i>
                                            </el-tooltip>
                                            <el-tooltip content="全关" placement="top">
                                                <i class="el-icon-circle-close header-action-btn close-all" @click="handleColumnBatchToggle(item, 'close')"></i>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row[getPermissionKey(item)]"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-color="#0084ff"
                                        inactive-color="#dcdfe6"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="250" align="center" fixed="right" v-if="perData && perData.allow_edit == 1">
                                <template slot-scope="scope">
                                    <el-button
                                        type="success"
                                        size="mini"
                                        icon="el-icon-check"
                                        @click="handleBatchToggle(scope.row, 'open')"
                                    >
                                        全开
                                    </el-button>
                                    <el-button
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-close"
                                        @click="handleBatchToggle(scope.row, 'close')"
                                    >
                                        全关
                                    </el-button>
<!--                                    <el-button-->
<!--                                        type="primary"-->
<!--                                        size="mini"-->
<!--                                        icon="el-icon-edit"-->
<!--                                        @click="handleEdit(scope.row.id, scope.row.word.chinese)"-->
<!--                                    >-->
<!--                                        编辑-->
<!--                                    </el-button>-->
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 分页 -->
<!--                        <div class="pagination-wrapper">-->
<!--                            <el-pagination-->
<!--                                background-->
<!--                                layout="total, prev, pager, next, jumper"-->
<!--                                :current-page="pageIndex"-->
<!--                                :page-size="pageSize"-->
<!--                                :total="pageTotal"-->
<!--                                @current-change="handlePageChange"-->
<!--                                @size-change="pageSizeChange"-->
<!--                            ></el-pagination>-->
<!--                        </div>-->
                    </el-tab-pane>

                    <!-- 报表权限标签页 -->
                    <el-tab-pane name="report">
                        <span slot="label">
                            <i class="el-icon-data-analysis"></i>
                            报表权限
                        </span>
                        <el-table
                            :data="tableArr"
                            border
                            stripe
                            style="width: 100%"
                            :header-cell-style="{ background: '#ecf5ff', color: '#0084ff', fontWeight: 'bold' }"
                            :span-method="reportSpanMethod"
                            v-loading="dataLoading"
                            element-loading-text="加载中..."
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 255, 255, 0.8)"
                        >
                            <el-table-column label="系统" width="150" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.type_name_s" class="system-name">
                                        {{ scope.row.word.type_name }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="word.chinese" label="页面" min-width="120" align="center"></el-table-column>
                            <el-table-column v-for="(item, index) in tableData2" :key="index" :label="item.chinese" width="120" align="center">
                                <template slot="header" slot-scope="scope">
                                    <div class="column-header">
                                        <span>{{ item.chinese }}</span>
                                        <div class="column-actions" v-if="perData && perData.allow_edit == 1">
                                            <el-tooltip content="全开" placement="top">
                                                <i class="el-icon-circle-check header-action-btn open-all" @click="handleReportColumnBatchToggle(item, 'open')"></i>
                                            </el-tooltip>
                                            <el-tooltip content="全关" placement="top">
                                                <i class="el-icon-circle-close header-action-btn close-all" @click="handleReportColumnBatchToggle(item, 'close')"></i>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row[getReportPermissionKey(item)]"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-color="#0084ff"
                                        inactive-color="#dcdfe6"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="250" align="center" fixed="right" v-if="perData && perData.allow_edit == 1">
                                <template slot-scope="scope">
                                    <el-button
                                        type="success"
                                        size="mini"
                                        icon="el-icon-check"
                                        @click="handleReportBatchToggle(scope.row, 'open')"
                                    >
                                        全开
                                    </el-button>
                                    <el-button
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-close"
                                        @click="handleReportBatchToggle(scope.row, 'close')"
                                    >
                                        全关
                                    </el-button>
<!--                                    <el-button-->
<!--                                        type="primary"-->
<!--                                        size="mini"-->
<!--                                        icon="el-icon-edit"-->
<!--                                        @click="handleEdit2(scope.row.code_id, scope.row.word.chinese)"-->
<!--                                    >-->
<!--                                        编辑-->
<!--                                    </el-button>-->
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 分页 -->
<!--                        <div class="pagination-wrapper">-->
<!--                            <el-pagination-->
<!--                                background-->
<!--                                layout="total, prev, pager, next, jumper"-->
<!--                                :current-page="pageIndex2"-->
<!--                                :page-size="pageSize2"-->
<!--                                :total="pageTotal2"-->
<!--                                @current-change="handlePageChange2"-->
<!--                                @size-change="pageSizeChange2"-->
<!--                            ></el-pagination>-->
<!--                        </div>-->
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </div>

        <!-- 固定底部批量操作按钮 -->
        <div class="fixed-batch-operation" v-if="perData && perData.allow_edit == 1">
            <el-button 
                type="primary" 
                icon="el-icon-check"
                @click="handleBatchSave"
                :loading="batchSaving"
            >
                {{ $t('common.save') }}
            </el-button>
            <el-button 
                icon="el-icon-refresh-left"
                @click="handleReset"
            >
                {{ $t('common.reset') }}
            </el-button>
        </div>

        <!-- 功能权限编辑弹窗 -->
        <el-dialog 
            :title="title + ' - 权限编辑'" 
            :visible.sync="editData.isshow" 
            width="60%"
            class="permission-dialog"
        >
            <div class="dialog-content" v-if="editData.data && editData.data.length > 0">
                <el-form label-width="120px" class="permission-form">
                    <el-form-item 
                        v-for="(item, index) in tableData" 
                        :key="'perm_' + item.chinese" 
                        :label="item.chinese"
                    >
                        <el-radio-group v-model="editData.data[0][getPermissionKey(item)]" @change="handleRadioChange(item.chinese, getPermissionKey(item), $event)">
                            <el-radio-button label="1">是</el-radio-button>
                            <el-radio-button label="0">否</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editData.isshow = false">取 消</el-button>
                <el-button type="primary" icon="el-icon-check" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 报表权限编辑弹窗 -->
        <el-dialog 
            :title="'报表页面 - ' + title2 + ' - 权限编辑'" 
            :visible.sync="tabData.isshow" 
            width="70%"
            class="report-permission-dialog"
        >
            <div class="dialog-content" v-if="tabData.data && tabData.data.length > 0">
                <!-- 基础权限配置 -->
                <el-card class="base-permission-card" shadow="never">
                    <div slot="header" class="card-header-small">
                        <i class="el-icon-setting"></i>
                        <span>基础权限</span>
                    </div>
                    <el-form label-width="100px" class="permission-form">
                        <el-form-item 
                            v-for="(item, index) in tableData2" 
                            :key="index" 
                            :label="item.chinese"
                        >
                            <el-radio-group v-model="tabData.data[0][getReportPermissionKey(item)]">
                                <el-radio-button label="1">是</el-radio-button>
                                <el-radio-button label="0">否</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </el-card>

                <!-- 详细数据配置 -->
                <el-card class="detail-data-card" shadow="never">
                    <div slot="header" class="card-header-small">
                        <i class="el-icon-s-data"></i>
                        <span>详细数据配置</span>
                        <div class="header-actions">
                            <el-button 
                                type="primary" 
                                size="small" 
                                icon="el-icon-plus" 
                                @click="insertEvent(-1)"
                            >
                                {{ $t('common.add') }}
                            </el-button>
                            <el-button 
                                type="danger" 
                                size="small" 
                                icon="el-icon-delete" 
                                @click="removeEvent()"
                            >
                                {{ $t('common.delete') }}
                            </el-button>
                        </div>
                    </div>
                    <vxe-table
                        border
                        stripe
                        resizable
                        keep-source
                        align="center"
                        ref="xTable1"
                        show-overflow
                        highlight-hover-row
                        :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true }"
                        :data="tabData.dtl"
                        :mouse-config="{ selected: true }"
                        :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa' }"
                        height="400"
                    >
                        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                        <vxe-table-column title="客户类型" field="cust_type" :edit-render="{}" min-width="180">
                            <template v-slot:edit="{ row }">
                                <el-select
                                    v-model="row.cust_type"
                                    :disabled="disabletype == 1"
                                    filterable
                                    placeholder="请选择客户类型"
                                >
                                    <el-option
                                        v-for="item in selectPull.cust_type"
                                        :key="item.kind_no"
                                        :label="item.kind_no + ' - ' + item.kind_name"
                                        :value="item.kind_no"
                                    ></el-option>
                                </el-select>
                            </template>
                            <template v-slot="{ row }">{{ getSelectLabel(row.cust_type, selectPull.cust_type) }}</template>
                        </vxe-table-column>
                        <vxe-table-column title="业务员" field="salesman_no" :edit-render="{}" min-width="180">
                            <template v-slot:edit="{ row }">
                                <el-select
                                    v-model="row.salesman_no"
                                    :disabled="disablesale == 1"
                                    filterable
                                    placeholder="请选择业务员"
                                >
                                    <el-option
                                        v-for="item in selectPull.salesman_no"
                                        :key="item.login_staff"
                                        :label="item.login_staff + ' - ' + item.staffr_name"
                                        :value="item.login_staff"
                                    ></el-option>
                                </el-select>
                            </template>
                            <template v-slot="{ row }">{{ getSelectLabel2(row.salesman_no, selectPull.salesman_no) }}</template>
                        </vxe-table-column>
                        <vxe-table-column title="仓库" field="counter_no" :edit-render="{}" min-width="180">
                            <template v-slot:edit="{ row }">
                                <el-select
                                    v-model="row.counter_no"
                                    filterable
                                    :disabled="disablecounter == 1"
                                    placeholder="请选择仓库"
                                >
                                    <el-option
                                        v-for="item in selectPull.counter_no"
                                        :key="item.kind_no"
                                        :label="item.kind_no + ' - ' + item.kind_name"
                                        :value="item.kind_no"
                                    ></el-option>
                                </el-select>
                            </template>
                            <template v-slot="{ row }">{{ getSelectLabel(row.counter_no, selectPull.counter_no) }}</template>
                        </vxe-table-column>
                    </vxe-table>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="tabData.isshow = false">取 消</el-button>
                <el-button type="primary" icon="el-icon-check" @click="saveEdit2">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiPermission,
    apiPermissionList,
    apimodifyPermission,
    apimodifyAllPermission,
    apiCurrentPermisson,
    apiPermissonDetail,
    apiPermissonCopy,
    apiPermissionLogin,
    apiPermissonCopyIt,
    apiPermissonLevel,
    apiPermissonSearch,
    apiPermissonDetailtable,
    apimodifyPermissionTable,
    apiPermissonAllow,
    apiPermissonAllowLowerprc
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            value: 1,
            activeTab: 'function', // 当前激活的标签页
            pageIndex: 1,
            pageSize: 15,
            pageIndex2: 1,
            pageSize2: 15,
            tableData: [],
            tableData2: [],
            selectData: [],
            perData: {},
            perData_cost: {
                allow_cost: 0,
                allow_lowerprc: 0
            },
            bar: '',
            user: '',
            permisson: [],
            title: '',
            title2: '',
            pageTotal: 0,
            pageTotal2: 0,
            editData: { isshow: false, scope: null, index: 0, data: {} },
            tabData: { isshow: false, scope: null, index: 0, data: {}, dtl: {} },
            levelData: [1, 2, 3, 4],
            level: '',
            lv_login: '',
            keyword: '',
            allow_cost: '',
            selectPull: [],
            tableArr: [],
            rptTable: [],
            disablecounter: '',
            disabletype: '',
            disablesale: '',
            batchSaving: false,
            dataLoading: false // 数据加载状态
        };
    },
    created() {
        this.getData();
        this.getDataList();
        this.getPull();
        this.getPermission();
        this.getSearchPull();
        this.user = localStorage.getItem('p_username');
    },
    activated() {
        this.getDataList();
        this.getPull();
        this.getPermission();
        this.user = localStorage.getItem('p_username');
    },
    watch: {
        // 监听编辑数据的变化
        'editData.data': {
            handler(newVal) {
                // 数据变化时的处理逻辑
            },
            deep: true
        }
    },
    methods: {
        //控制开关操作
        switchClick() {
            this.lv_login = !!this.lv_login;

            var lv_login;
            if (this.lv_login == true) {
                lv_login = 1;
            } else {
                lv_login = 0;
            }
            apiPermissionLogin({
                lv_login: lv_login,
                login_staff: this.user
            }).then((res) => {});
            // this.getDataList()
        },
        // 获取表头信息
        getData() {
            apiPermissionList({}).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.tableData2 = res.data.data_rpt;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '13'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data || {};
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取表格内容信息
        getDataList() {
            this.dataLoading = true; // 开始加载
            apiPermission({
                login_staff: localStorage.getItem('p_username'),
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.keyword,
                page_rep: this.pageIndex2,
                page_rep_size: this.pageSize2
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData_cost = res.data || {
                        allow_cost: 0,
                        allow_lowerprc: 0
                    };
                    this.pageTotal = res.data.page_total || 0;
                    // 处理权限数据，确保权限字段为数字类型
                    const permissionData = res.data.data || [];
                    this.permisson = permissionData.map(item => {
                        // 创建副本并转换权限字段为数字
                        const newItem = { ...item };
                        // 遍历所有可能的权限字段并转换为数字
                        const permissionKeys = ['allow_use', 'allow_add', 'allow_edit', 'allow_dele', 'allow_print', 'allow_check', 'allow_checkoff'];
                        permissionKeys.forEach(key => {
                            if (newItem.hasOwnProperty(key)) {
                                newItem[key] = Number(newItem[key]) || 0;
                            }
                        });
                        return newItem;
                    });
                    // 处理报表权限数据，确保权限字段为数字类型
                    const reportData = res.data.data_report || [];
                    this.tableArr = reportData.map(item => {
                        const newItem = { ...item };
                        const reportPermissionKeys = ['allow_use', 'allow_print'];
                        reportPermissionKeys.forEach(key => {
                            if (newItem.hasOwnProperty(key)) {
                                newItem[key] = Number(newItem[key]) || 0;
                            }
                        });
                        return newItem;
                    });
                    this.pageTotal2 = res.data.page_rep_total || 0;
                    this.level = res.data.level || '';
                    if (res.data.lv_login == 1) {
                        this.lv_login = true;
                    } else {
                        this.lv_login = false;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            }).finally(() => {
                this.dataLoading = false; // 结束加载
            });
        },
        //复制的对象下拉列表
        getPull() {
            apiPermissonCopy({}).then((res) => {
                if (res.code == 2000) {
                    this.selectData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //复制权限
        handleCopy: function () {
            if (this.bar == '') {
                this.$message.error('请选择要复制的对象');
            } else {
                apiPermissonCopyIt({
                    login_staff: this.user,
                    login_staff_cope: this.bar
                }).then((res) => {
                    if (res.code == 2000) {
                        this.getDataList();
                        this.getPull();
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(id, name) {
            apiPermissonDetail({
                id: id
            }).then((res) => {
                if (res.code == 2000 && res.data) {
                    // 使用深拷贝避免数据引用问题
                    this.editData.data = [JSON.parse(JSON.stringify(res.data))];
                    this.title = name;
                    this.$nextTick(() => {
                        this.editData.isshow = true;
                    });
                } else {
                    this.$message.error(res.msg || '获取权限详情失败');
                }
            }).catch(err => {
                console.error('获取权限详情错误:', err);
                this.$message.error('获取权限详情失败');
            });
        },
        // 保存编辑
        saveEdit() {
            if (!this.editData.data || !this.editData.data.length || !this.editData.data[0]) {
                this.$message.error('数据异常，请重新打开编辑');
                return;
            }
            
            let data = this.editData.data;

            apimodifyPermission({
                allow_use: data[0].allow_use,
                allow_add: data[0].allow_add,
                allow_edit: data[0].allow_edit,
                allow_dele: data[0].allow_dele,
                allow_print: data[0].allow_print,
                allow_check: data[0].allow_check,
                allow_checkoff: data[0].allow_checkoff,
                id: data[0].id
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.editData.isshow = false;
                    this.getData();
                    this.getDataList();
                } else {
                    this.$message.error(res.data.info);
                }
            }).catch(err => {
                console.error('保存权限错误:', err);
                this.$message.error('保存失败');
            });
        },
        handleEdit2(id, name) {
            apiPermissonDetailtable({
                code_id: id,
                login_staff: this.user
            }).then((res) => {
                if (res.code == 2000 && res.data && res.data.popedom) {
                    this.tabData.data = [res.data.popedom];
                    this.tabData.dtl = res.data.rpt || [];
                    this.title2 = name;
                    this.disablecounter = res.data.counter_no;
                    this.disabletype = res.data.cust_type;
                    this.disablesale = res.data.salesman_no;
                    this.$nextTick(() => {
                        this.tabData.isshow = true;
                    });
                } else {
                    this.$message.error(res.msg || '获取报表权限详情失败');
                }
            }).catch(err => {
                console.error('获取报表权限详情错误:', err);
                this.$message.error('获取报表权限详情失败');
            });
        },
        // 保存编辑
        saveEdit2() {
            if (!this.tabData.data || !this.tabData.data.length || !this.tabData.data[0]) {
                this.$message.error('数据异常，请重新打开编辑');
                return;
            }
            
            let data = this.tabData.data;
            var table1 = this.$refs.xTable1.getTableData().fullData;

            apimodifyPermissionTable({
                login_staff: this.user,
                allow_use: data[0].allow_use,
                allow_print: data[0].allow_print,
                code_id: data[0].code_id,
                rpt: table1
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.tabData.isshow = false;
                    this.getData();
                    this.getDataList();
                } else {
                    this.$message.error(res.data.info);
                }
            }).catch(err => {
                console.error('保存报表权限错误:', err);
                this.$message.error('保存失败');
            });
        },
        async insertEvent(row) {
            let record = {};
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow);
        },
        removeEvent() {
            let length = this.$refs.xTable1.getCheckboxRecords();
            if (length.length == 0) {
                this.$message.error('请选择你要删除的');
            } else {
                // this.$XModal.confirm('您确定要删除该数据?').then(type => {
                //     if (type === 'confirm') {
                this.$refs.xTable1.removeCheckboxRow();
                //     }
                // })
            }
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getDataList();
        },
        handlePageChange2(val) {
            this.pageIndex2 = val;
            this.getDataList();
        },
        pageSizeChange2(val) {
            //
            this.pageSize2 = val;
            this.getDataList();
        },
        // 启用按钮
        tableDatastates(row) {
            apiPermissonAllow({ allow_cost: row, login_staff: this.user }).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: res.msg, type: 'success' });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 启用按钮
        tableDatastatesLowerprc(row) {
            apiPermissonAllowLowerprc({ allow_lowerprc: row, login_staff: this.user }).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: res.msg, type: 'success' });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        selectLevel: function () {
            apiPermissonLevel({
                login_staff: this.user,
                level: this.level
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success('设置成功');
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getSearchPull() {
            apiPermissonSearch({}).then((res) => {
                if (res.code == 2000) {
                    this.selectPull = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getSelectLabel(value, list) {
            if (list) {
                let item = list.find((item) => item.kind_no === value);
                return item ? item.kind_name : null;
            }
        },
        getSelectLabel2(value, list) {
            if (list) {
                let item = list.find((item) => item.login_staff === value);
                return item ? item.staffr_name : null;
            }
        },
        // 获取权限键名
        getPermissionKey(item) {
            const keyMap = {
                '查看': 'allow_use',
                '添加': 'allow_add',      // 接口返回的是"添加"
                '新增': 'allow_add',      // 兼容"新增"
                '修改': 'allow_edit',
                '打印': 'allow_print',
                '审核': 'allow_check',
                '删除': 'allow_dele',
                '反审': 'allow_checkoff', // 接口返回的是"反审"
                '反审核': 'allow_checkoff' // 兼容"反审核"
            };
            return keyMap[item.chinese] || 'allow_use';
        },
        // Radio 变化处理
        handleRadioChange(fieldName, fieldKey, value) {
            // Radio 值变化时的处理逻辑
        },
        // 获取报表权限键名
        getReportPermissionKey(item) {
            const keyMap = {
                '查看': 'allow_use',
                '打印': 'allow_print'
            };
            return keyMap[item.chinese] || 'allow_use';
        },
        // 获取权限值
        getPermissionValue(row, key) {
            if (!row || !key) return 0;
            const value = row[key];
            // 处理字符串 "1" 或数字 1 的情况
            return value === '1' || value === 1 ? 1 : 0;
        },
        // 获取报表权限值
        getReportPermissionValue(row, key) {
            if (!row || !key) return 0;
            const value = row[key];
            // 处理字符串 "1" 或数字 1 的情况
            return value === '1' || value === 1 ? 1 : 0;
        },
        // 获取权限标签类型
        getPermissionType(row, key) {
            return this.getPermissionValue(row, key) == 1 ? 'success' : 'danger';
        },
        // 获取报表权限标签类型
        getReportPermissionType(row, key) {
            return this.getReportPermissionValue(row, key) == 1 ? 'success' : 'danger';
        },
        // Tabs 标签页切换
        handleTabClick(tab) {
            console.log('切换到标签页:', tab.name);
            // 如果需要，可以在这里添加切换时的逻辑
        },
        // 功能权限表格合并单元格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 系统列（第一列）合并
            if (columnIndex === 0) {
                if (row.type_name_s) {
                    // 计算需要合并的行数
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.permisson.length; i++) {
                        if (this.permisson[i].word.type_name === row.word.type_name) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return [rowspan, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        // 报表权限表格合并单元格
        reportSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 系统列（第一列）合并
            if (columnIndex === 0) {
                if (row.type_name_s) {
                    // 计算需要合并的行数
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.tableArr.length; i++) {
                        if (this.tableArr[i].word.type_name === row.word.type_name) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return [rowspan, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        // 批量保存所有权限
        handleBatchSave() {
            this.$confirm('确认保存所有模块的权限设置？', '提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            }).then(() => {
                this.batchSaving = true;
                // 调用批量保存接口
                apimodifyAllPermission({
                    login_staff: this.user,
                    permisson: this.permisson,
                    rptpermisson: this.tableArr
                }).then((res) => {
                    this.batchSaving = false;
                    if (res.code == 2000) {
                        this.$message({ message: '批量保存成功', type: 'success' });
                        this.getData();
                        this.getDataList();
                    } else {
                        this.$message.error(res.msg || '保存失败');
                    }
                }).catch(err => {
                    this.batchSaving = false;
                    console.error('批量保存权限错误:', err);
                    this.$message.error('保存失败');
                });
            }).catch(() => {
                // 用户取消操作
            });
        },
        // 重置权限数据
        handleReset() {
            this.$confirm('确认重置为上次保存的权限设置？', '提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            }).then(() => {
                // 重新获取数据
                this.getDataList();
                this.$message({ message: '已重置', type: 'success' });
            }).catch(() => {
                // 用户取消操作
            });
        },
        // 功能权限批量开关
        handleBatchToggle(row, type) {
            const permissionKeys = ['allow_use', 'allow_add', 'allow_edit', 'allow_dele', 'allow_print', 'allow_check', 'allow_checkoff'];
            const value = type === 'open' ? 1 : 0;
            permissionKeys.forEach(key => {
                if (row.hasOwnProperty(key)) {
                    row[key] = value;
                }
            });
        },
        // 报表权限批量开关
        handleReportBatchToggle(row, type) {
            const reportPermissionKeys = ['allow_use', 'allow_print'];
            const value = type === 'open' ? 1 : 0;
            reportPermissionKeys.forEach(key => {
                if (row.hasOwnProperty(key)) {
                    row[key] = value;
                }
            });
        },
        // 功能权限按列批量开关
        handleColumnBatchToggle(item, type) {
            const permissionKey = this.getPermissionKey(item);
            const value = type === 'open' ? 1 : 0;
            this.permisson.forEach(row => {
                if (row.hasOwnProperty(permissionKey)) {
                    row[permissionKey] = value;
                }
            });
            this.$message.success(`已将所有模块的"${item.chinese}"权限${type === 'open' ? '开启' : '关闭'}`);
        },
        // 报表权限按列批量开关
        handleReportColumnBatchToggle(item, type) {
            const permissionKey = this.getReportPermissionKey(item);
            const value = type === 'open' ? 1 : 0;
            this.tableArr.forEach(row => {
                if (row.hasOwnProperty(permissionKey)) {
                    row[permissionKey] = value;
                }
            });
            this.$message.success(`已将所有报表的"${item.chinese}"权限${type === 'open' ? '开启' : '关闭'}`);
        }
    }
};
</script>

<style scoped>
/* 容器样式 */
.permission-container {
    background: #f5f7fa;
    min-height: calc(100vh - 60px);
    padding-bottom: 80px; /* 为固定底部按钮留出空间 */
}

.crumbs {
    margin-bottom: 20px;
}

.container {
    max-width: 100%;
}

/* 操作卡片样式 */
.operation-card {
    margin-bottom: 20px;
    border-radius: 8px;
}

.operation-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* 操作行 - 左右布局 */
.operation-row {
    display: flex;
    gap: 15px;
}

.operation-section {
    padding: 15px;
    background: #f9fafc;
    border-radius: 6px;
    border-left: 4px solid #0084ff;
}

.operation-section.one-third {
    flex: 1;
    min-width: 0;
}

.operation-section.two-thirds {
    flex: 2;
    min-width: 0;
}

.section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
}

.section-title i {
    color: #0084ff;
    font-size: 16px;
}

.section-content {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.user-select {
    flex: 1;
    min-width: 180px;
}

.level-select {
    width: 140px;
}

/* 等级说明图标 */
.info-icon {
    color: #0084ff;
    font-size: 16px;
    cursor: help;
    margin-left: 5px;
}

/* 选项标签样式 */
.option-label {
    display: flex;
    align-items: center;
    gap: 10px;
}

.staff-code {
    color: #909399;
    font-size: 12px;
}

.staff-name {
    color: #303133;
    font-size: 14px;
}

/* 权限配置区域 */
.permission-config {
    display: flex;
    gap: 25px;
    flex-wrap: wrap;
    align-items: center;
}

.config-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.config-label {
    font-size: 14px;
    color: #606266;
    font-weight: 500;
}


/* 用户信息横幅 - 顶部显示 */
.user-info-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.user-info-banner i {
    font-size: 20px;
}

.user-info-banner strong {
    font-size: 16px;
    margin: 0 4px;
}

/* 表格卡片样式 */
.table-card {
    margin-bottom: 20px;
    border-radius: 8px;
}

/* Tabs 样式优化 */
.table-card ::v-deep .el-tabs__header {
    margin: 0;
    background: #f5f7fa;
    padding: 10px 20px 0;
    border-radius: 8px 8px 0 0;
}

.table-card ::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
}

.table-card ::v-deep .el-tabs__item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s;
}

.table-card ::v-deep .el-tabs__item i {
    margin-right: 5px;
    font-size: 16px;
}

.table-card ::v-deep .el-tabs__item.is-active {
    color: #0084ff;
    font-weight: 600;
}

.table-card ::v-deep .el-tabs__active-bar {
    background-color: #0084ff;
    height: 3px;
}

.table-card ::v-deep .el-tabs__content {
    padding: 20px;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.card-header i {
    color: #0084ff;
    font-size: 18px;
}

.system-name {
    font-weight: 600;
    color: #0084ff;
    font-size: 14px;
}

.pagination-wrapper {
    margin-top: 20px;
    text-align: right;
}

/* 批量操作按钮区域 */
.batch-operation-wrapper {
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    gap: 15px;
    padding: 15px;
    background: #f9fafc;
    border-radius: 6px;
}

.batch-operation-wrapper .el-button {
    min-width: 120px;
}

/* 固定底部批量操作按钮 */
.fixed-batch-operation {
    position: fixed;
    bottom: 0;
    left: 200px; /* 避开左侧导航栏 */
    right: 0;
    z-index: 100;
    display: flex;
    justify-content: flex-end; /* 按钮右对齐 */
    align-items: center;
    gap: 15px;
    padding: 15px 30px;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
}

.fixed-batch-operation .el-button {
    min-width: 140px;
    height: 40px;
    font-size: 15px;
    font-weight: 500;
}

/* 弹窗样式 */
.dialog-content {
    padding: 10px;
}

.permission-form {
    max-height: 500px;
    overflow-y: auto;
}

.permission-form ::v-deep .el-form-item {
    margin-bottom: 18px;
}

.permission-form ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
}

.permission-form ::v-deep .el-radio-button__inner {
    padding: 8px 20px;
}

.permission-form ::v-deep .el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #dcdfe6;
}

.permission-form ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #0084ff;
    border-color: #0084ff;
    box-shadow: -1px 0 0 0 #0084ff;
}

/* 报表权限弹窗 */
.base-permission-card,
.detail-data-card {
    margin-bottom: 15px;
}

.card-header-small {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.card-header-small > div:first-child {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-header-small i {
    color: #0084ff;
    font-size: 16px;
}

.header-actions {
    display: flex;
    gap: 8px;
}

/* 滚动条美化 */
.permission-form::-webkit-scrollbar {
    width: 6px;
}

.permission-form::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
}

.permission-form::-webkit-scrollbar-thumb:hover {
    background: #c0c4cc;
}

/* 表头操作按钮样式 */
.column-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.column-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

.header-action-btn {
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
    padding: 2px;
}

.header-action-btn.open-all {
    color: #67c23a;
}

.header-action-btn.open-all:hover {
    color: #85ce61;
    transform: scale(1.2);
}

.header-action-btn.close-all {
    color: #f56c6c;
}

.header-action-btn.close-all:hover {
    color: #f78989;
    transform: scale(1.2);
}
</style>

<style>
/* 全局表格样式 */
.el-table thead {
    color: #000;
    font-weight: bold;
}

/* 表头字体加大加粗 */
.el-table th {
    background: #ecf5ff !important;
    color: #0084ff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    padding: 12px 0 !important;
}

/* 表格内容字体调整 */
.el-table td {
    font-size: 14px !important;
    color: #303133 !important;
    font-weight: 400;
    padding: 10px 0 !important;
}

/* 系统名称列 */
.system-name {
    font-weight: 600;
    color: #0084ff;
    font-size: 14px;
}

/* 页面名称列 */
.el-table .el-table__body td:nth-child(2) {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
}

/* Tag 标签样式优化 */
.el-table .el-tag {
    font-size: 13px !important;
    font-weight: 500 !important;
    padding: 0 10px !important;
    height: 24px !important;
    line-height: 22px !important;
}

/* 成功状态的 Tag（是） */
.el-table .el-tag--success {
    background-color: #f0f9ff !important;
    border-color: #0084ff !important;
    color: #0084ff !important;
}

/* 危险状态的 Tag（否） */
.el-table .el-tag--danger {
    background-color: #fef0f0 !important;
    border-color: #f56c6c !important;
    color: #f56c6c !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}

/* 弹窗按钮样式 */
.permission-dialog .dialog-footer,
.report-permission-dialog .dialog-footer {
    padding: 10px 20px;
    text-align: right;
    border-top: 1px solid #ebeef5;
}

.permission-dialog .dialog-footer .el-button,
.report-permission-dialog .dialog-footer .el-button {
    min-width: 80px;
}

/* vxe-table 样式优化 */
.vxe-table {
    border-radius: 4px;
}

.vxe-table .vxe-body--row.row--stripe {
    background: #fafafa;
}

.vxe-table .vxe-body--row.row--hover {
    background: #ecf5ff;
}
</style>
